import { createAction, props } from "@ngrx/store";
import { AuthUser } from "../shared/models/auth-user.model";

/*
  Action convention:
    Between [] the source of the action in the applicaton. To avoid dispatching same action in different screens
    Then the event or command
 */

export const login = createAction(
  "[Login Page] User login",
  props<{user: AuthUser}>()
);

export const logout = createAction(
  "[Side Menu] User logout"
);
